import {
  events,
  events_white,
  e_shop,
  private_function,
  restaurant_reservation,
} from '../../assets/base64';
import { IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { Alert } from '../../services/alert';
import { NavigationService } from '../../services/navigation';
import { store } from '../../services/redux';
import { logout } from '../../services/redux/reducers/AuthSlice';

export const DASHBOARD_MENU = [
  {
    title: 'NOTICES \n',
    icon: require('../../assets/notices.png'),
    onPress: () => {},
  },
  {
    title: 'MY ACCOUNT\n',
    icon: require('../../assets/my-account.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MyAccountTab',
      });
    },
    requiredLogin: true,
  },
  {
    title: 'MY BOOKINGS\n',
    icon: require('../../assets/my-bookings.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MyBookingsTab',
      });
    },
    requiredLogin: true,
  },
  {
    title: 'MY PROFILE\n',
    icon: require('../../assets/my-profile.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MyAccountTab',
      });
    },
    requiredLogin: true,
  },
  {
    title: 'SERVICES & FORMS\n',
    icon: require('../../assets/services-forms.png'),
    onPress: () => {
      NavigationService.push('ServiceForm');
    },
    requiredLogin: true,
  },
];

export const DASHBOARD_DESTOP_MENU = [
  {
    title: 'MAKE BOOKING',
    icon: require('../../assets/events.png'),
    onPress: () => {
      NavigationService.push('Root', {
        screen: 'HomeTab',
      });
    },
    requiredLogin: true,
  },
  {
    title: 'MESSAGES',
    icon: IS_WEB
      ? addBase64Prefix(events_white)
      : require('../../assets/events.png'),
    onPress: () => {
      NavigationService.push('Root', {
        screen: 'Messages',
      });
    },
    requiredLogin: true,
  },
  {
    title: 'ACTIVITIES',
    icon: IS_WEB
      ? addBase64Prefix(restaurant_reservation)
      : require('../../assets/restaurant-reservation.png'),
    onPress: () => {
      NavigationService.push('Root', {
        screen: 'Activities',
      });
    },
    requiredLogin: true,
  },
  {
    title: 'MY ACCOUNT',
    icon: IS_WEB
      ? addBase64Prefix(private_function)
      : require('../../assets/private-function.png'),
    onPress: () => {
      NavigationService.push('Root', {
        screen: 'MenuTab',
        params: {
          screen: 'MyProfile',
        },
      });
    },
    requiredLogin: true,
  },
];

export const DASHBOARD_DESTOP_MENU_VOLUNTEER_INTRUCTOR = [
  {
    title: 'BOOK ACTIVITIES',
    icon: require('../../assets/activities-icon.png'),
    onPress: () => {},
    requiredLogin: true,
  },
  {
    title: 'UPCOMING BOOKINGS',
    icon: require('../../assets/events.png'),
    onPress: () => {},
    requiredLogin: true,
  },
  {
    title: 'MY ACCOUNT',
    icon: require('../../assets/account-icon.png'),
    onPress: () => {
      NavigationService.push('Root', {
        screen: 'MenuTab',
        params: {
          screen: 'MyProfile',
        },
      });
    },
    requiredLogin: true,
  },
  {
    title: 'CONTACT US',
    icon: require('../../assets/letter-round.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MenuTab',
        params: {
          screen: 'ContactUs',
        },
      });
    },
    requiredLogin: true,
  },
  {
    title: 'LOG OUT',
    icon: require('../../assets/logout-icon.png'),
    onPress: () => {
      Alert.alert('Logout', 'You want to logout?', [
        {
          text: 'Ok',
          onPress: () => {
            store.dispatch(logout());
            NavigationService.push('Auth');
          },
        },
        {
          text: 'Cancel',
          onPress: () => {},
        },
      ]);
    },
    requiredLogin: true,
  },
];
